
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/form.module.css'

import { getLayout, LayoutContext } from '../../components/sg/Layout'
import Form, { Step } from '../../components/Form'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import Router, { useRouter } from 'next/router'
import { useContext, useState } from 'react'
import { useLivePrice, usePremiums } from '../../hooks/usePrices'
import Link from 'next/link'

import Head from 'next/head'
import { historicGain } from '../../helpers/historicGain'

const shopUrl = process.env.NEXT_PUBLIC_GSA_SHOP_URL

export default function Tour () {
  const { t } = useTranslation('main')
  const router = useRouter()
  const { locale } = router
  const [layoutContext] = useContext(LayoutContext)
  const { currency } = layoutContext
  // const { price: { value: spotPrice }, products: { AuGrams: { purchase: purchasePrice, sellback: sellbackPrice } }, lockInPeriod, maxTransactionAmount, maxUnfundedAmount, maxWithdrawalAmount, fx } = useLivePrice(currency, 'gld')
  const { price: { value: spotPrice }, lockInPeriod, maxTransactionAmount, maxUnfundedAmount, spotFx } = useLivePrice(currency)
  const { gld: gldPremium, sil: silPremium, plt: pltPremium } = usePremiums(currency, locale)
  const c = classNames.bind(style)
  const [currentStep, setCurrentStep] = useState('welcome')

  // const buyPremium = (purchasePrice - spotPrice) / spotPrice
  const steps = ['welcome', 'buying', 'limits', 'holding', 'redeem', 'withdraw', 'start']
  const { gain: centuryGain, pastDate } = historicGain(spotPrice, spotFx)

  return (
    <>
      <Head>
        <title>{t('tour-pagetitle')}</title>
      </Head>
      <Form
        title={t('tour-title')}
        onClose={() => Router.push('/portfolio')}
        onBack={currentStep !== 'welcome' ? () => setCurrentStep(steps[steps.findIndex(s => s === currentStep) - 1]) : undefined}
        onForward={currentStep !== 'start' ? () => setCurrentStep(steps[steps.findIndex(s => s === currentStep) + 1]) : undefined}
        step={currentStep}
      >
        <Step name='welcome'>
          <div className={c('welcome')}>
            <img src='/images/tour-logo.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-welcome-title')}</h3>
            <p>{t('tour-welcome-body-1')}</p>
            <p>{t('tour-welcome-body-2', { averageGain: isNaN(centuryGain) ? '~8%' : centuryGain.toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }), gainSinceYear: pastDate.getFullYear() })}</p>
            <p className={c('subtext')}>{t('tour-welcome-note')}</p>
            <br />
            <button type='button' onClick={() => setCurrentStep('buying')}>{t('tour-buyingbutton')}</button> &nbsp; &nbsp; 1/7
            <br /><br />
          </div>
        </Step>
        <Step name='buying'>
          <div className={c('buying')}>
            <img src='/images/tour-buysell.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-buying-title')}</h3>
            <p>{t('tour-buying-body-0')}</p>
            <p>{t('tour-buying-body-1', { lockInPeriod: lockInPeriod || 30 })}</p>
            <p>
              <b>{t('tour-buying-body-2', { goldPremium: gldPremium.buy, silverPremium: silPremium.buy, platinumPremium: pltPremium.buy })}</b>
            </p>
            <br />
            <button type='button' onClick={() => setCurrentStep('limits')}>{t('tour-limitsbutton')}</button> &nbsp; &nbsp; 2/7
            <br /><br />
          </div>
        </Step>
        <Step name='limits'>
          <div className={c('limits')}>
            <img src='/images/tour-limits.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-limits-title')}</h3>
            <p>
              {t('tour-limits-body-1', { decigramPrice: (spotPrice / 100 || 0.86).toLocaleString(locale, { style: 'currency', currency: currency || 'SGD', currencyDisplay: 'code', maximumFractionDigits: 2, minimumFractionDigits: 2 }) })}
              <b> {t('tour-limits-body-2', { maxAmountPerDay: (maxTransactionAmount || 500000).toLocaleString(locale, { style: 'currency', currency: 'SGD', currencyDisplay: 'code', maximumFractionDigits: 0, minimumFractionDigits: 0 }) })}</b> {t('tour-limits-body-3', { maxAmountGrams: (maxTransactionAmount / spotPrice || 0).toLocaleString(locale, { maximumFractionDigits: 2, minimumFractionDigits: 0 }) })} {t('tour-limits-body-4')}
            </p>
            <p className={c('note')}>
              <b>{t('tour-limits-note-1')}</b> {t('tour-limits-note-2', { maxUnfundedAmount: (maxUnfundedAmount || 20000).toLocaleString(locale, { style: 'currency', currency: 'SGD', currencyDisplay: 'code', maximumFractionDigits: 0, minimumFractionDigits: 0 }) })}
            </p>
            <br />
            <button type='button' onClick={() => setCurrentStep('holding')}>{t('tour-holdingbutton')}</button> &nbsp; &nbsp; 3/7
            <br /><br />
          </div>
        </Step>
        <Step name='holding'>
          <div className={c('holding')}>
            <img src='/images/tour-holding.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-holding-title')}</h3>
            <p>
              <b>{t('tour-holding-body-1')}</b>
            </p>
            <p>
              {t('tour-holding-body-2')} <Link href='/sg/pricing'><a>{t('tour-holding-body-3')}</a></Link>
            </p>
            <p className={c('note')}>
              <b>{t('tour-holding-note-1')}</b> {t('tour-holding-note-2')}
            </p>
            <br />
            <button type='button' onClick={() => setCurrentStep('redeem')}>{t('tour-redeembutton')}</button> &nbsp; &nbsp; 4/7
            <br /><br />
          </div>
        </Step>
        <Step name='redeem'>
          <div className={c('redeem')}>
            <img src='/images/tour-redeem.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-redeem-title')}</h3>
            <p>
              {t('tour-redeem-body-1')} <a href={shopUrl} target='_blank' rel='noopener noreferrer'>{t('tour-redeem-onlineshop')}</a> {t('tour-redeem-body-2')} <Link href='/sg/contact'><a>{t('tour-redeem-bullionshopsg')}</a></Link>
            </p>
            <p>
              {t('tour-redeem-body-3')}
              <br /><a href='/explore' target='_blank' rel='noopener'>{t('tour-redeem-explorebacking-link')}</a>
            </p>
            <br />
            <button type='button' onClick={() => setCurrentStep('withdraw')}>{t('tour-withdrawbutton')}</button> &nbsp; &nbsp; 5/7
            <br /><br />
          </div>
        </Step>
        <Step name='withdraw'>
          <div className={c('withdraw')}>
            <img src='/images/tour-withdraw.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-withdraw-title')}</h3>
            <p>
              {t('tour-withdraw-body-1')}
            </p>
            <p>
              {t('tour-withdraw-body-2')}
            </p>
            <br />
            <button type='button' onClick={() => setCurrentStep('start')}>{t('tour-startbutton')}</button> &nbsp; &nbsp; 6/7
            <br /><br />
          </div>
        </Step>
        <Step name='start'>
          <div className={c('start')}>
            <img src='/images/tour-start.svg' style={{ margin: '0 -.3em 1em', borderRadius: '.5em', objectFit: 'cover', width: 'calc(100% + .6em)', height: '100px' }} />
            <h3>{t('tour-start-title')}</h3>
            <p>
              {t('tour-start-body-1')}
            </p>
            <p>
              {t('tour-start-body-2')}
            </p>
            <p>
              <b>{t('tour-start-cta')}</b>
            </p>
            <img src='/images/gold3d.svg' style={{ float: 'right', width: '100px' }} />
            <br />
            <br />
            <button type='button' className='pulsate' onClick={() => Router.push('/portfolio')}>{t('tour-openportfolio')}</button>
            <br /><br />
          </div>
        </Step>
      </Form>
    </>
  )
}

Tour.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/tour',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  